import LibraryAssetChunk from "./LibraryAssetChunk.tsx";
import {
  useLibraryExploreFetcher,
  useLibraryFetcher,
} from "./libraryLoader.ts";
import { useEffect } from "react";
import { Fetcher } from "react-router-dom";

export function LoadableLibraryAssetChunk({
  page,
  onSetFetcher,
}: {
  page: number;
  onSetFetcher: (fetcher: Fetcher) => void;
}) {
  const fetcher = useLibraryFetcher();
  const exploreFetcher = useLibraryExploreFetcher();

  useEffect(() => {
    onSetFetcher(fetcher);
  }, [onSetFetcher, fetcher]);

  useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(`/my-library/assets/${page}`);

      // Current fraction behavior: On the initial load of My Library, fetch and show explore
      // information for the most recent 25 explore assets. Other explore endpoints may further
      // populate the shared asset data store and augment more "My Library" elements
      //
      // Here will fetch that same first page of explore assets and augment the first page of
      // library results with it, as that will similarly cover the vast majority of users.
      if (page === 1) {
        exploreFetcher.load("/my-library/recent-explore-assets");
      }
    }
  }, [fetcher, page, exploreFetcher]);

  if (fetcher.data && fetcher.data.ok && fetcher.data.data) {
    const allAssets = fetcher.data.data.map((asset) => ({
      ...asset,
      explore: exploreFetcher.data?.[asset.manageAsset.vbid],
    }));

    return <LibraryAssetChunk assets={allAssets} focusFirstCard={page !== 1} />;
  }
}
